module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-7-3c1345eb0036574b011ce75ee9799983.webp";